export const urls = {
  checkout: (cartId: number | string) => `/api/client/v1/carts/${cartId}/checkout/`,
};

export const keys = {
  all: () => ["checkout-all"],
  // state
  state: () => [...keys.all(), "state"],
  lastCheckoutOrder: () => [...keys.state(), "last-checked-out-order"],
};
